import * as types from './mutation-types'
import * as storage from '../storage'

export const ActionDefinirDadosCarrinho = ({ commit, state }, dadosCarrinho) => {
  commit(types.SET_DADOS_CARRINHO, dadosCarrinho)
  storage.setItensCarrinho(state.itens)
}

export const ActionLimparDadosCarrinho = ({ commit }) => {
  commit(types.LIMPAR_DADOS_CARRINHO)
  storage.deleteItensCarrinho()
}

export const ActionAdicionarItemCarrinho = ({ commit, state }, item) => {
  commit(types.SET_ADICIONAR_ITEM_CARRINHO, item)
  storage.setItensCarrinho(state.itens)
}

export const ActionRemoverItemCarrinho = ({ commit, state }, { item, indice }) => {
  commit(types.REMOVER_ITEM_CARRINHO, { item, indice })
  storage.setItensCarrinho(state.itens)
}

export const ActionAumentarQuantidadeItemCarrinho = ({ commit, state }, { item, indice }) => {
  commit(types.AUMENTAR_QUANTIDADE_ITEM_CARRINHO, { item, indice })
  storage.setItensCarrinho(state.itens)
}

export const ActionDiminuirQuantidadeItemCarrinho = ({ commit, state }, { item, indice }) => {
  commit(types.DIMINUIR_QUANTIDADE_ITEM_CARRINHO, { item, indice })
  storage.setItensCarrinho(state.itens)
}

export const ActionDefinirCupomDataDoCarrinho = ({ commit }, cupom) => {
  commit(types.SET_CUPOM_DATA_DO_CARRINHO, cupom)
  storage.setCupomDataDoCarrinho(cupom)
}

export const ActionLimparCupomDataDoCarrinho = ({ commit }) => {
  commit(types.SET_CUPOM_DATA_DO_CARRINHO, {})
  storage.setCupomDataDoCarrinho('')
}
